import { useCallback, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { jsonAxios } from 'components/axios';
import First from 'components/issue/list/First';
import { ISearchInfo } from 'types/issue';
import { countryCodeToEmoji, pointCountry } from 'components/function';
import MyPageTemplate from 'components/template/MyPageTemplate';

const BlList = () => {
    interface IIssue {
        blNo: string,
        orderId: number,
        title: string,
        createAt: string,
        originCode: string,
        originAddress: string,
        destinationCode: string,
        destinationAddress: string
        hasUnconfirmed: boolean
    }

    const navigate = useNavigate();
    const [list, setList] = useState<IIssue[]>([]);
    const [searchInfo, setSearchInfo] = useState<ISearchInfo>({
        fromDate: '',
        toDate: '',
        search: '',
        pageSize: 10,
        page: 1,
    });

    const tHeader = [
        { label: "이슈발생일", flex: 0.5 },
        { label: "BL", flex: 0.5 },
        { label: "제목", flex: 1.0 },
        { label: "출발지", flex: 1.0 },
        { label: "도착지", flex: 1.0 },
    ];

    const init = useCallback(() => {
        const params = new URLSearchParams(Object.entries(searchInfo)).toString();
        jsonAxios.get(`issue/bl?${params}`).then(res => {
            if (res.data.code === 200) {
                setList(res.data.data)
            }
        })
    }, [searchInfo]);

    useEffect(() => {
        init();
    }, [init]);

    const titleStyle = () => {
        return `hidden tablet:block flex-[0.5] w-full bg-[#e5e5e5] py-1`
    }

    const tBodyStyle = () => {
        return `flex items-center justify-center py-2 text-center tablet:py-0 tablet:gap-2`
    }

    return (
        <MyPageTemplate background='bg-[#F8F8FA]'>
            <div className="flex flex-col gap-10 tablet:gap-4 mb-6 pt-10 tablet:pt-4 h-full min-h-dvh">
                <First
                    title='사고/이슈 알림 검색'
                    searchInfo={searchInfo}
                    setSearchInfo={setSearchInfo}
                    init={init}
                />

                <div className='flex flex-col gap-6 bg-white p-10 tablet:p-4 min-h-[50vh]'>
                    <div className='tablet:hidden flex bg-[#F8F8FA] font-semibold text-sm 2xl:text-base'>
                        {
                            tHeader.map((item, idx) => (
                                <div
                                    key={idx}
                                    className={`flex-[${item.flex}] flex items-center justify-center h-15`}
                                >
                                    {item.label}
                                </div>
                            ))
                        }
                    </div>
                    {
                        list.length > 0 ?
                            list.map((item, idx) => (
                                <div
                                    className={`relative flex text-sm border border-[#E1E1E8] transition-all rounded tablet:flex-col tablet:gap-1 xl:h-20 hover:bg-[#EEF4FF] cursor-pointer`}
                                    key={idx}
                                    onClick={() => {
                                        navigate(`/mypage/issue/issueList?id=${item.orderId}`)
                                    }}
                                >
                                    {
                                        item.hasUnconfirmed &&
                                        <div className='top-0 left-0 absolute bg-red px-2.5 py-1.5 rounded-full font-semibold text-white text-xs'>NEW</div>
                                    }
                                    <div className={`flex-[0.5] ${tBodyStyle()} tablet:order-1`}>
                                        <span className={titleStyle()}>{tHeader[0].label}</span>
                                        <span className='flex-1'>
                                            {item.createAt}
                                        </span>
                                    </div>
                                    <div className={`flex-[0.5] ${tBodyStyle()} tablet:order-2`}>
                                        <span className={titleStyle()}>{tHeader[1].label}</span>
                                        <span className='flex-1'>
                                            {item.blNo}
                                        </span>
                                    </div>
                                    <div className={`flex-[1.0] ${tBodyStyle()} tablet:order-3`}>
                                        <span className={titleStyle()}>{tHeader[2].label}</span>
                                        <span className='flex-1'>
                                            {item.title}
                                        </span>
                                    </div>
                                    <div className={`flex-[1.0] ${tBodyStyle()} tablet:order-4`}>
                                        <span className={titleStyle()}>{tHeader[3].label}</span>
                                        <div className='flex flex-1 justify-center items-center'>
                                            <p className='text-lg flag'>{countryCodeToEmoji(item.originCode.slice(0, 2))}</p>
                                            <p dangerouslySetInnerHTML={{ __html: pointCountry(item.originCode) }}></p>
                                            <p>{item.originAddress}</p>
                                        </div>
                                    </div>
                                    <div className={`flex-[1.0] ${tBodyStyle()} tablet:order-5`}>
                                        <span className={titleStyle()}>{tHeader[4].label}</span>
                                        <div className='flex flex-1 justify-center items-center'>
                                            <p className='text-lg flag'>{countryCodeToEmoji(item.destinationCode.slice(0, 2))}</p>
                                            <p dangerouslySetInnerHTML={{ __html: pointCountry(item.destinationCode) }}></p>
                                            <p>{item.destinationAddress}</p>
                                        </div>
                                    </div>
                                </div>
                            ))
                            :
                            <div className='flex justify-center items-center py-6 min-h-[30vh]'>
                                데이터가 없습니다.
                            </div>
                    }
                </div>
            </div>
        </MyPageTemplate>
    )
}

export default BlList